module.exports = __webpack_public_path__ + "media/images/promo/championship/01-c1488df2b065d8c59498543bf6c1604d.png";